import type { CSSProperties } from "react";

interface BrandWordmarkProps {
  className?: string;
  style?: CSSProperties;
  /**
   * A host's own product name, replacing "BunnyCal" entirely.
   *
   * <p>Rendered as a single span in one colour. The two-tone Bunny/Cal split is BunnyCal's own
   * identity, not a generic style: applying it to someone else's name would break at an arbitrary
   * point ("Acme Sch|eduling") and read as a rendering bug.
   */
  name?: string | null;
}

export function BrandWordmark({ className, style, name }: BrandWordmarkProps) {
  const base: CSSProperties = { display: "inline-flex", alignItems: "baseline", lineHeight: 1, ...style };

  if (name) {
    // A text node, never markup — the server validates the name's shape, and React escapes it.
    return (
      <span className={className} style={{ ...base, color: "var(--plum-900, #1F1530)" }}>
        {name}
      </span>
    );
  }

  return (
    <span className={className} style={base}>
      <span style={{ color: "var(--plum-500, #5E4E99)" }}>Bunny</span>
      <span style={{ color: "var(--plum-900, #1F1530)" }}>Cal</span>
    </span>
  );
}
